import { ReactElement, SyntheticEvent, useEffect } from 'react';
import { Box, Button, Divider, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { EEventCreateSteps } from '../../types/@event';
import { useDispatch, useSelector } from 'react-redux';
import { IOrganisation } from '../../types/@organisation';
import { eventActions } from '../../redux/slices/event.slice';
import { organisationActions } from '../../redux/slices/organisation.slice';
import { RootState } from '../../redux/store';

import { styles } from './event-create-organisation.styles';

interface IProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const EventCreateOrganisation = ({ setStep }: IProps): ReactElement => {
  const dispatch = useDispatch();
  const organisationList: IOrganisation[] = useSelector((state: RootState) => state.organisations.all);
  const eventOrganisation = useSelector((state: RootState) => state.events.eventCreate.organisation);

  const handleNext = (): void => {
    setStep(() => {
      return EEventCreateSteps.team;
    });
  };
  const handleBack = (): void => {
    setStep(() => {
      return EEventCreateSteps.association;
    });
  };

  const handleClick = (ev: SyntheticEvent<HTMLElement>) => {
    const {
      dataset: { idx },
    } = ev.currentTarget as typeof ev.currentTarget & {
      dataset: { idx: string };
    };
    dispatch(eventActions.selectedOrganisation(organisationList[+idx]));
  };

  useEffect(() => {
    dispatch(organisationActions.getOrganisations());
  }, [dispatch]);

  return (
    <Box sx={styles.mainBox}>
      <Box sx={styles.titleBox}>Select Organisation</Box>
      <Box sx={styles.contentBox}>
        <List sx={styles.listBox}>
          {organisationList.map((el, idx) => {
            return (
              <ListItem disablePadding key={el._id}>
                <ListItemButton onClick={handleClick} data-idx={idx}>
                  <ListItemText>{el.name}</ListItemText>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
        <Divider orientation="vertical" sx={styles.divider} />
        <Box sx={styles.reflectBox}>{eventOrganisation.name}</Box>
      </Box>
      <Box sx={styles.buttonsBox}>
        <Button sx={styles.backButton} onClick={handleBack}>
          back
        </Button>
        <Button sx={styles.buttonNext} onClick={handleNext}>
          next
        </Button>
      </Box>
    </Box>
  );
};

export default EventCreateOrganisation;
